module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"AresLoading":{"button":"Načíst údaje z ARES","errors":{"invalidTin":"Zadejte platné IČ.","notFound":"Údaje z ARES nebyly nalezeny.","unavailable":"ARES je nyní nedostupný. Zkuste to prosím později."}}}}')
  delete Component.options._Ctor
}
